<template>
  <Row :has-line="false">
    <template #icon-left>
      <BulletAsset :color="color" />
    </template>
    <template #top-left>
      <Heading :level="5">
        {{ name }}
      </Heading>
    </template>
    <template #top-right>
      <Heading :level="5">
        {{ percentage }}
      </Heading>
    </template>
  </Row>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Heading, Row } from '@warrenbrasil/nebraska-web';
import { BulletAsset } from '@/modules/common/components/BulletAsset';

@Component({
  components: {
    BulletAsset,
    Heading,
    Row
  }
})
export default class HeadingProductListItem extends Vue {
  @Prop({ type: String, required: true })
  private name!: string;

  @Prop({ type: String, required: true })
  private percentage!: string;

  @Prop({ type: String, required: true })
  private color!: string;
}
</script>
